import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import id from "@irati/utils/id";
import { FormattedMessage } from "@irati/utils/lang";
import Link, { RouterLink } from "@irati/ui/src/Link";
import tracking from "@irati-tracking/platform";
import partiallyComplete from "@irati/ui/images/partiallyComplete.svg";
import { Card, Logo, Flex, StyledPara, Img, TextWrapper } from "./styled";
var ProductCard = function (props, _a) {
    var apps = _a.apps;
    var product = props.product, to = props.to, href = props.href, label = props.label, logo = props.logo, hint = props.hint, trackingName = props.trackingName;
    var cardId = id(product + "ProductCard", "home");
    var card = (React.createElement(Card, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Logo, null, logo))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(TextWrapper, null,
                    React.createElement(FormattedMessage, { id: label }),
                    hint &&
                        React.createElement(Flex, null,
                            React.createElement(StyledPara, { flush: true, light: true, large: true },
                                React.createElement(FormattedMessage, { id: hint })),
                            React.createElement(Img, { src: partiallyComplete })))))));
    if (to) {
        return (React.createElement(RouterLink, { id: cardId, to: to, app: apps[product], onClick: function () { return tracking.click("homepage_card", { product: trackingName, active: true }); } }, card));
    }
    else if (href) {
        return (React.createElement(Link, { id: cardId, href: href, target: "_blank", onClick: function () { return tracking.click("homepage_card", { product: trackingName, active: false }); } }, card));
    }
    else {
        return card;
    }
};
ProductCard.contextTypes = {
    apps: PropTypes.object
};
export default ProductCard;
